<template>
    <div class="or-about-text flex-column flex-center">
        <p class="text">{{text}}</p>
    </div>
</template>

<script>
export default {
    props: {
        text: String,
    },
}
</script>

<style scoped>
    .or-about-text {
        margin: 0 auto;
        width: 900px;
    }
    .text {
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        color: #FFFFFF;
    }
</style>